var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v(" "+_vm._s(_vm.official_display ? ("©2020 - " + (new Date().getFullYear()) + " 广州健食慧软件技术有限公司 版权所有") : "")+" 版本："+_vm._s(_vm.version))])}
var staticRenderFns = []

export { render, staticRenderFns }